module.exports = __webpack_public_path__ + "static/media/keaser.76cd6b35.jpg";